import { ReactElement } from 'react';
import { useDialog } from '~/hooks';
import { DialogSection } from '../dialog-section.component';
import { StyledModal as Dialog } from '../dialog.style';

interface Props {
  target: ReactElement;
}

export const MembershipExplainerDialog = ({ target }: Props) => {
  const { isOpen, close, TargetComponent } = useDialog(target);

  return (
    <>
      {TargetComponent}
      <Dialog isOpen={isOpen} onDismiss={close} aria-label="Membership Explainer">
        <Dialog.Header title="Membership explained" onClose={close} />
        <DialogSection>
          Arcadia allows you to power your home with clean and renewable energy, without changing
          your electricity service.
        </DialogSection>
        <DialogSection title="How does it work?">
          {[
            'We sync with your utility to track your electricity usage. We source, verify, purchase and retire RECs for you. You are now using clean and renewable energy each month.',
          ]}
        </DialogSection>
        <DialogSection title="What is a REC?">
          {[
            'Renewable energy certificates track clean and renewable energy as it moves through the US power grid. When a renewable energy supplier, like a wind or solar farm, produces 1MWh of electricity, exactly one (1) REC is created. That REC can now be purchased and retired by anyone who uses 1MWh of electricity. When that happens, they have officially used that renewable energy. Arcadia partners with renewable energy suppliers to source, verify, purchase and retire RECs on your behalf.',
          ]}
        </DialogSection>
        <Dialog.FooterStacked primaryText="Close" onSubmit={close} />
      </Dialog>
    </>
  );
};
